import { useTranslation } from 'react-i18next';

export function ServiceUnavailablePage() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-dvh items-center justify-center bg-[var(--fv-bg)] p-6">
      <div className="max-w-md text-center">
        <h1 className="text-xl font-bold text-[var(--fv-primary)]">{t('app.name')}</h1>
        <p className="mt-4 text-sm text-[var(--fv-text-muted)]">{t('errors.unavailable')}</p>
      </div>
    </div>
  );
}
